// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"d3cddb1c","140":"91cc6b90","248":"5b33027c","292":"d0b388a9","476":"34644315","652":"3ac83dba","760":"9485b93e","956":"6a63652d"}[chunkId] + ".chunk.css";
};